import { PROGRAM_SETTINGS } from '@/constants/programSettings';
import { Grid } from '@mui/material';
import { REGEX } from '@/constants/regex';
import { SVPercentageInput } from '@/components/core';

export const SavingsInterestRateControls = () => {
  const { PROGRAM_LEVEL_SAVINGS_INTEREST_RATE } =
    PROGRAM_SETTINGS.SAVINGS_INTEREST_RATE_CONTROLS;

  return (
    <>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6, lg: 6 }}>
          <SVPercentageInput
            name="rateSavingInterest"
            label={PROGRAM_LEVEL_SAVINGS_INTEREST_RATE.LABEL}
            rules={{
              pattern: {
                regex: REGEX.DECIMAL_NUMBER,
                readablePatternName: 'percentage',
              },
              min: 0,
              max: 100,
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};
